import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from '@env';

if (environment.production) {
	enableProdMode();
}

platformBrowserDynamic()
	.bootstrapModule(AppModule)
	.catch((err) => console.error(err));

/**
 * Prevent scrollIntoView from bubbling past the iframe in embedded links.
 * Needs to be called before any code that might invoke scrollIntoView().
 */
if (window.self !== window.top) {
	Element.prototype.scrollIntoView = function (opts?: ScrollIntoViewOptions) {
		const behavior = opts && typeof opts === 'object' && 'behavior' in opts ? (opts as ScrollIntoViewOptions).behavior : 'auto';
		const margin = 16; // padding so the element isn't flush to the edge // arbitrarily picked

		const isScrollableY = (el: Element) => {
			const cs = getComputedStyle(el as HTMLElement);
			return /(auto|scroll|overlay)/.test(cs.overflowY) && (el as HTMLElement).scrollHeight > (el as HTMLElement).clientHeight;
		};

		const scrollContainer = (container: Element | null) => {
			if (!container) {
				return;
			}
			const cRect = (container as HTMLElement).getBoundingClientRect();
			const eRect = (this as Element).getBoundingClientRect();

			const topDelta = Math.min(0, eRect.top - cRect.top - margin); // how far the element sticks out above / below the container viewport
			const botDelta = Math.max(0, eRect.bottom - cRect.bottom + margin);
			const deltaY = topDelta || botDelta; // prefer the minimal movement

			if (deltaY) {
				if (container === document.scrollingElement) {
					window.scrollBy({ top: deltaY, behavior });
				} else {
					(container as HTMLElement).scrollBy({ top: deltaY, behavior });
				}
			}
		};

		let node: Element | null = (this as Element).parentElement; // scroll each scrollable ancestor (deepest -> out)
		const ancestors: Element[] = [];
		while (node && node !== document.documentElement) {
			if (isScrollableY(node)) {
				ancestors.push(node);
			}
			node = node.parentElement;
		}

		for (let i = 0; i < ancestors.length; i++) {
			scrollContainer(ancestors[i]);
		}

		scrollContainer(document.scrollingElement); // if still not fully visible, scroll the frame's root
	};
}
